import { render, staticRenderFns } from "./Appeals.vue?vue&type=template&id=ee41970a&scoped=true&"
import script from "./Appeals.vue?vue&type=script&lang=ts&"
export * from "./Appeals.vue?vue&type=script&lang=ts&"
import style0 from "./Appeals.vue?vue&type=style&index=0&id=ee41970a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee41970a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
